import React from "react";
import { LeftPart } from "./LeftPart";
import { useLocation } from "react-router-dom";
import { RightPart } from "./RightPart";

export const SectionDetail = () => {
  const location = useLocation();
  const section = location.state.section;
  const sections = location.state.sections;
  return (
    <div className="section-detail-page" id="content">
      <div className="container">
        <div className="row">
          <LeftPart section={section} />
          <RightPart sections={sections} />
        </div>
      </div>
    </div>
  );
};
